var Tabs = function() {

	this.init = function() {

		this.tabs();

	}

	this.tabs = function(){

		$('.tabs li').click(function() {
			if (!$(this).hasClass("tabLinkUrl")) {

				var tab_id = $(this).attr('data-tab');

				$('.tabs li').removeClass('current');
				$('.tab-content').removeClass('current');

				$(this).addClass('current');
				$("#" + tab_id).addClass('current');
			}
		});

	}

	return this.init();

}
